import { IAction } from '../../interface/action/action.interface';
import { RoutesConfig } from '../../routes';
import { isActionInRoutes } from './is-action-in-routes';
import { ConfigurationModel } from '../../model/configuration.model';

export function isRouteAction(action: IAction, config: ConfigurationModel): boolean {
  return isActionInRoutes(action, RoutesConfig(config.silentCallbackUrl));
}
